import Client from 'shopify-buy/index.unoptimized.umd';
import * as Sentry from '@sentry/vue';

export const storeFrontVariantId = (variantId) => {
  return Buffer.from(`gid://shopify/ProductVariant/${variantId}`).toString('base64');
};

export default defineNuxtPlugin((nuxtApp) => {
  const { locale, locales } = nuxtApp.$i18n;

  const { shopifyApiAccessToken, shopifyApiDomain } = locales.value?.find((l) => l.code === locale.value) || {};

  const config = {
    domain: shopifyApiDomain,
    storefrontAccessToken: shopifyApiAccessToken,
    language: locale.value,
  };

  const educationCheckoutUrl = async (variantId) => {
    const lineItems = [{ variantId: storeFrontVariantId(variantId), quantity: 1 }];
    try {
      const client = Client.buildClient(config);
      let checkout = await client.checkout.create();
      checkout = await client.checkout.addLineItems(checkout.id, lineItems);
      if (checkout.lineItems.length === 0) throw new Error('Education could not be added to checkout');
      return checkout.webUrl;
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
      return null;
    }
  };

  return {
    provide: {
      educationCheckoutUrl,
    },
  };
});
